export const BRAND_NAME = 'Shaon Landmarks & Housing';

export const SITE_URL =
  import.meta.env.VITE_SITE_URL ?? 'https://shaon-landmarks.pages.dev';
export const WHATSAPP_NUMBER =
  import.meta.env.VITE_WHATSAPP_NUMBER ?? '+8801712345678';
export const WHATSAPP_MSG = encodeURIComponent(
  "Hello! I'm interested in Shaon Landmarks & Housing properties.",
);
export const CONTACT_PHONE =
  import.meta.env.VITE_CONTACT_PHONE ?? '+8801712345678';
export const CONTACT_EMAIL =
  import.meta.env.VITE_CONTACT_EMAIL ?? 'info@shaonlandmarks.com';

export const EMAILJS_PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY ?? '';
export const EMAILJS_SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID ?? '';
export const EMAILJS_TEMPLATE_ID =
  import.meta.env.VITE_EMAILJS_TEMPLATE_ID ?? '';
export const EMAILJS_NEWSLETTER_TEMPLATE_ID =
  import.meta.env.VITE_EMAILJS_NEWSLETTER_TEMPLATE_ID ?? '';
